/* eslint-disable max-len */

export const SearchIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Search Icon">
        <mask
          id="mask0_2771_3099"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_2771_3099)">
          <path
            id="Vector"
            d="M11 18.6719C8.76667 18.6719 6.875 17.8969 5.325 16.3469C3.775 14.7969 3 12.9052 3 10.6719C3 8.43854 3.775 6.54688 5.325 4.99688C6.875 3.44687 8.76667 2.67188 11 2.67188C13.2333 2.67188 15.125 3.44687 16.675 4.99688C18.225 6.54688 19 8.43854 19 10.6719C19 11.6052 18.85 12.4844 18.55 13.3094C18.25 14.1344 17.8333 14.8885 17.3 15.5719L21.3 19.5719C21.4833 19.7552 21.575 19.9885 21.575 20.2719C21.575 20.5552 21.4833 20.7885 21.3 20.9719C21.1167 21.1552 20.8833 21.2469 20.6 21.2469C20.3167 21.2469 20.0833 21.1552 19.9 20.9719L15.9 16.9719C15.2167 17.5052 14.4625 17.9219 13.6375 18.2219C12.8125 18.5219 11.9333 18.6719 11 18.6719ZM11 16.6719C12.6667 16.6719 14.0833 16.0885 15.25 14.9219C16.4167 13.7552 17 12.3385 17 10.6719C17 9.00521 16.4167 7.58854 15.25 6.42188C14.0833 5.25521 12.6667 4.67188 11 4.67188C9.33333 4.67188 7.91667 5.25521 6.75 6.42188C5.58333 7.58854 5 9.00521 5 10.6719C5 12.3385 5.58333 13.7552 6.75 14.9219C7.91667 16.0885 9.33333 16.6719 11 16.6719Z"
            fill="#6B7280"
          />
        </g>
      </g>
    </svg>
  );
};
